import {
    Building2,
    Cloud,
    Handshake,
    Network,
    Repeat,
    Server,
    Wrench,
} from "lucide-react";

const metrics = [
    { value: "1", label: "piattaforma", sub: "tutto collegato" },
    { value: "0", label: "copia-incolla inutili", sub: "dati unici" },
    { value: "100%", label: "tracciabilità operativa", sub: "log e storico" },
    {
        value: "∞",
        label: "dashboard cliente integrata",
        sub: "portale dedicato",
    },
];

const audience = [
    {
        icon: Cloud,
        title: "MSP",
        text: "Provider di servizi gestiti che monitorano contratti ricorrenti, licenze e SLA operativi.",
    },
    {
        icon: Network,
        title: "System Integrator",
        text: "Chi costruisce infrastrutture e ne segue il ciclo di vita: progetti, dispositivi e assistenza.",
    },
    {
        icon: Wrench,
        title: "Aziende di assistenza tecnica",
        text: "Team che gestiscono interventi, rapportini, contratti prepagati e storico cliente.",
    },
    {
        icon: Building2,
        title: "Rivenditori IT",
        text: "Chi combina vendita, servizi e supporto: dal preventivo alla licenza attivata.",
    },
    {
        icon: Server,
        title: "Provider di servizi cloud",
        text: "Realtà che gestiscono servizi Microsoft 365, Azure, Sophos e altri stack collegati al cliente.",
    },
    {
        icon: Repeat,
        title: "Realtà con contratti ricorrenti",
        text: "Chi vive di rinnovi, servizi flat, monte ore e ha bisogno di tenere sotto controllo scadenze e marginalità.",
    },
    {
        icon: Handshake,
        title: "Aziende con portafoglio clienti da monitorare",
        text: "Chi vuole una vista unica su clienti, servizi attivi, dispositivi e opportunità commerciali.",
    },
];

export default function MetricsAudience() {
    return (
        <>
            {/* METRICS */}
            <section
                id="numeri"
                data-testid="metrics-section"
                className="relative overflow-hidden bg-gradient-to-br from-[#0B1120] via-[#0e1628] to-[#0f172a] text-white py-24 sm:py-28 lg:py-32"
            >
                <div className="absolute inset-0 grid-bg opacity-50" aria-hidden />
                <div className="absolute -top-24 right-1/3 w-96 h-96 rounded-full bg-cyan-500/10 blur-3xl" aria-hidden />

                <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                    <div className="max-w-3xl">
                        <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-teal-300">
                            <span className="h-px w-8 bg-teal-400" />
                            Vantaggi
                        </span>
                        <h2
                            data-testid="metrics-title"
                            className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight"
                        >
                            Un dato inserito una volta, disponibile ovunque serva.
                        </h2>
                        <p className="mt-5 text-lg text-slate-300 leading-relaxed">
                            Ogni informazione diventa disponibile nella scheda cliente, nei report, nei contratti,
                            nello storico e nel portale — senza duplicazioni.
                        </p>
                    </div>

                    <div
                        data-testid="metrics-grid"
                        className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4"
                    >
                        {metrics.map((m) => (
                            <div
                                key={m.label}
                                data-testid={`metric-${m.label}`}
                                className="reveal rounded-2xl bg-white/[0.03] ring-1 ring-white/10 backdrop-blur p-7 hover:bg-white/[0.06] hover:ring-cyan-400/30 transition"
                            >
                                <p className="font-display text-5xl sm:text-6xl font-extrabold leading-none bg-gradient-to-br from-white via-cyan-200 to-teal-300 bg-clip-text text-transparent">
                                    {m.value}
                                </p>
                                <p className="mt-4 text-base font-semibold text-white">
                                    {m.label}
                                </p>
                                <p className="mt-1 text-sm text-slate-400">{m.sub}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* AUDIENCE */}
            <section
                id="per-chi"
                data-testid="audience-section"
                className="relative bg-white py-24 sm:py-28 lg:py-32"
            >
                <div className="max-w-7xl mx-auto px-6 lg:px-8">
                    <div className="max-w-3xl">
                        <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-cyan-700">
                            <span className="h-px w-8 bg-cyan-500" />
                            Per chi è pensato
                        </span>
                        <h2
                            data-testid="audience-title"
                            className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900"
                        >
                            Pensato per chi gestisce servizi IT ogni giorno.
                        </h2>
                    </div>

                    <div
                        data-testid="audience-grid"
                        className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
                    >
                        {audience.map((a) => (
                            <div
                                key={a.title}
                                data-testid={`audience-card-${a.title}`}
                                className="reveal group rounded-2xl bg-slate-50 ring-1 ring-slate-200 p-6 hover:bg-white hover:ring-cyan-400/40 hover:shadow-md transition"
                            >
                                <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-white ring-1 ring-slate-200 text-cyan-600 group-hover:bg-gradient-to-br group-hover:from-cyan-500 group-hover:to-teal-400 group-hover:text-white transition">
                                    <a.icon className="w-4.5 h-4.5" strokeWidth={2.25} />
                                </span>
                                <h3 className="mt-4 font-display text-[17px] font-semibold text-slate-900">
                                    {a.title}
                                </h3>
                                <p className="mt-2 text-[14px] leading-relaxed text-slate-600">
                                    {a.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
